import { createContext } from 'react';
export var TranslationContext = createContext({
  locale: 'en',
  translate: function translate(id) {
    return id;
  }
});